module.exports = __webpack_public_path__ + "img/horizontal_3_1_pp1_7042.7e12fd5d.png";